import { useTheme } from '../context/ThemeContext';
import { useGuestPrompt } from '../context/GuestPromptContext';

// Inline empty-state shown inside protected screens (Collection, Chat, etc.)
// when a guest navigates to them. Replaces card / chat list content with a
// friendly sign-in prompt.
const GuestEmptyState = ({ title, body, action = 'Create Account' }) => {
  const { theme, isDark } = useTheme();
  const { promptSignIn } = useGuestPrompt();
  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '48px 24px',
      textAlign: 'center',
      gap: 12,
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: '50%',
        background: isDark ? 'rgba(56,189,248,0.12)' : 'rgba(14,165,233,0.10)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: theme.accent,
        marginBottom: 8,
      }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" />
        </svg>
      </div>
      <h2 style={{ color: theme.text, fontSize: 18, fontWeight: 700, margin: 0 }}>{title}</h2>
      <p style={{ color: theme.textSecondary, fontSize: 14, margin: 0, lineHeight: 1.4, maxWidth: 320 }}>{body}</p>
      <button
        type="button"
        onClick={() => promptSignIn(title.toLowerCase().replace(/^create an account to /, ''))}
        style={{
          marginTop: 16,
          padding: '12px 28px',
          background: theme.accent,
          color: '#fff',
          border: 'none', borderRadius: 10,
          fontSize: 15, fontWeight: 600, cursor: 'pointer',
        }}
      >
        {action}
      </button>
    </div>
  );
};

export default GuestEmptyState;
